import React from "react";
import { Link, useParams } from "react-router-dom";
import { 
  Box, Typography, Stack, IconButton, 
  Divider, alpha, useTheme, List, ListItem, ListItemButton, ListItemIcon, ListItemText 
} from "@mui/material";
import { 
  AutoFixHigh, ChevronRight, RateReview, 
  Visibility, SettingsSuggest, ReportProblem, 
  LocalHospital, Analytics, Vaccines, 
  Today, Map 
} from "@mui/icons-material";

const WhatElse = () => {
  const { id: clientID } = useParams();
  const theme = useTheme();

  const actionLinks = [
    { text: "Write a communication note", to: `/${clientID}/communication`, icon: <RateReview /> },
    { text: "Observation list", to: `/Observation/${clientID}`, icon: <Visibility /> },
    // { text: "Edit drop down lists", to: "/ReferenceManagement", icon: <SettingsSuggest /> },
    { text: "Accident/Incident form", to: "/incident-report", icon: <ReportProblem /> },
    { text: "Hospital transfer form", to: null, icon: <LocalHospital /> },
    { text: "How do I do audits", to: "/AuditStats", icon: <Analytics /> },
    { text: "Record vaccinations", to: "/vaccination-record", icon: <Vaccines /> },
    { text: "View my daily schedule", to: `/visit-analysis/${clientID}`, icon: <Today /> },
    { text: "Visit Analysis", to: "/VisitAnalysis", icon: <Map /> },
  ];

  return (
    <Box>
      {/* Header - Consistent with Dashboard Theme */}
      <Box 
        sx={{ 
          p: 1.8, 
          display: 'flex', 
          alignItems: 'center',
          bgcolor: alpha(theme.palette.primary.main, 0.03)
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <AutoFixHigh color="primary" sx={{ fontSize: 20 }} />
          <Typography 
            variant="subtitle1" 
            fontWeight={800} 
            sx={{ color: theme.palette.primary.main, fontSize: '0.95rem' }}
          >
            Quick Actions
          </Typography>
        </Stack>
      </Box>

      <Divider />

      {/* Body - Clean Navigation List */}
      <Box sx={{ p: 1 }}>
        <List disablePadding>
          {actionLinks.map((item, index) => (
            <ListItem 
              key={index} 
              disablePadding 
              sx={{ 
                mb: 0.5,
                '&:last-child': { mb: 0 }
              }}
            >
              <ListItemButton 
                component={item.to ? Link : "div"}
                to={item.to}
                sx={{ 
                  borderRadius: 2,
                  py: 0.8,
                  px: 1.5,
                  transition: '0.2s',
                  '&:hover': { 
                    bgcolor: alpha(theme.palette.primary.main, 0.05),
                    '& .arrow-icon': { transform: 'translateX(4px)', color: 'primary.main' }
                  },
                  cursor: item.to ? 'pointer' : 'default',
                  opacity: item.to ? 1 : 0.7 // লিঙ্ক না থাকলে একটু হালকা দেখাবে
                }}
              >
                <ListItemIcon sx={{ minWidth: 32, color: 'primary.main', opacity: 0.8 }}>
                  {React.cloneElement(item.icon, { sx: { fontSize: 18 } })}
                </ListItemIcon>
                
                <ListItemText 
                  primary={item.text} 
                  primaryTypographyProps={{ 
                    fontSize: '0.82rem', 
                    fontWeight: 600, 
                    color: '#334155' 
                  }} 
                />

                {item.to && (
                  <ChevronRight 
                    className="arrow-icon"
                    sx={{ 
                      fontSize: 16, 
                      color: 'text.disabled', 
                      transition: '0.3s' 
                    }} 
                  />
                )}
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default WhatElse;